import React, { Component } from 'react';
import { Row, Col, Label, CardBody, Card, Form, FormGroup, Button } from 'reactstrap';
import DatePicker from 'react-datepicker';
import { toast } from 'react-toastify';
import { fetchMisOrderData } from './action';
import withAuth from '../../components/Services/WithAuth';
import { Preloading } from '../../components/UI/Preloader/action.js';
import { connect } from 'react-redux';
import './style.scss';
import {
    FROM_DATE,
    TO_DATE,
    EXCEL_FORMAT_TYPE,
    MIS_ORDER_DATA_DEFAULT_FILE_NAME,
    INVALID_DATE_RANGE_MSG,
    DATE_FORMAT, MIS_ORDER_GENERATION_SUCCESS_MSG, INTERNAL_SERVER_ERROR_MSG
} from './constant.js';
import fileSaver from 'file-saver';
import { format, isValid } from 'date-fns';
class MisOrderData extends Component {
    constructor() {
        super();
        this.state = {
            fromDate: null,
            toDate: null
        }
    }

    componentDidUpdate(prevProps) {
        const { misOrderDataFile, misOrderDataError } = this.props;
        if (misOrderDataFile && misOrderDataFile !== prevProps.misOrderDataFile) {

            var fileName = MIS_ORDER_DATA_DEFAULT_FILE_NAME + '.xlsx';
            var blob = new Blob([misOrderDataFile], { type: EXCEL_FORMAT_TYPE });
            fileSaver.saveAs(blob, fileName);
            this.displaySuccessMessage(MIS_ORDER_GENERATION_SUCCESS_MSG);
            this.props.preloading(false);
            this.setState({ fromDate: null, toDate: null })
        }
        if (misOrderDataError !== prevProps.misOrderDataError) {
            this.props.preloading(false);
            this.setState({ fromDate: null, toDate: null })
            if (misOrderDataError && misOrderDataError.data)
                misOrderDataError.data.text().then((resp) => { this.displayErrorMessage(resp) });
            else
                this.displayErrorMessage(INTERNAL_SERVER_ERROR_MSG);
        }
    }

    onChangeDate = (date, type) => {
        switch (type) {
            case FROM_DATE:
                this.setState({ fromDate: date })
                break;
            case TO_DATE:
                this.setState({ toDate: date })
                break;
            default: return;
        }
    }
    handleFetchMisOrderData = (e) => {
        e.preventDefault();
        if (this.state.fromDate && this.state.toDate && this.state.fromDate > this.state.toDate) {
            this.displayErrorMessage(INVALID_DATE_RANGE_MSG);
            this.setState({
                fromDate: null,
                toDate: null
            });

        }
        else {
            var request =
            {
                fromDate: format(this.state.fromDate, DATE_FORMAT),
                toDate: format(this.state.toDate, DATE_FORMAT)
            }
            this.props.fetchMisOrderData(request);
            this.props.preloading(true);

        }
    }

    displayErrorMessage = (message) => {
        toast.error(
            <div>
                <i className="fa fa-exclamation-triangle"></i>&nbsp; {message}
            </div>
        )
    }

    displaySuccessMessage = (message) => {
        toast.success(
            <div>
                {message}
            </div>
        )
    }

    render() {
        return (
            <Col>
                <div className="d-flex justify-content-between align-items-center mb-3">
                    <h4 className="mb-0">Mis Order Data</h4>
                </div>
                <Card>
                    <CardBody >
                        <Form className="w-100" >
                            <FormGroup row>
                                <Label sm={10} className="text-secondary font-weight-bold"> Select date range to extract order data</Label>
                            </FormGroup>
                            <FormGroup className="general-form-style" row>
                                <Label sm={3}>From Date:</Label>
                                <Row>
                                    <Col sm='30'>
                                        <DatePicker className="form-control" name="FromDate" onChange={(date) => this.onChangeDate(date, FROM_DATE)} dateFormat="dd-MM-yyyy" selected={(this.state.fromDate) ? this.state.fromDate : null} placeholderText='Start Date:DD-MM-YYYY' popperPlacement='bottom'
                                        />
                                    </Col>
                                </Row>
                            </FormGroup>
                            <FormGroup className="general-form-style" row>
                                <Label sm={3}>To Date:</Label>
                                <Row>
                                    <Col sm='30'>
                                        <DatePicker className="form-control" name="ToDate" onChange={(date) => this.onChangeDate(date, TO_DATE)} dateFormat="dd-MM-yyyy" selected={(this.state.toDate) ? this.state.toDate : null} placeholderText='End Date:DD-MM-YYYY' />
                                    </Col>
                                </Row>
                            </FormGroup>
                            <FormGroup className="generate-order-btn" row>
                                <Row >
                                    <Col xs="30" >

                                        <Button color="primary" className="btn" onClick={(e) => this.handleFetchMisOrderData(e)} disabled={!this.state.fromDate || !this.state.toDate}>Generate Order Data</Button>

                                    </Col>
                                </Row>
                            </FormGroup>
                        </Form>
                    </CardBody>
                </Card>
            </Col>
        )
    }

}
const mapStateToProps = (state, ownProps) => ({

    misOrderDataFile: state.misOrderDataReducer.misOrderDataFile,
    misOrderDataError: state.misOrderDataReducer.misOrderDataError

})

const mapDispatchToProps = (dispatch, ownProps) => ({
    fetchMisOrderData: (data) => { dispatch(fetchMisOrderData(data)) },
    preloading: (isPreloading) => { dispatch(Preloading(isPreloading)) }
})

export default withAuth(connect(
    mapStateToProps,
    mapDispatchToProps
)(MisOrderData));

